import { Dropdown } from "react-bootstrap";
import { useThemeContext } from "../../../../../theme/ThemeContext";
import { Theme } from "../../../../../../constant/Theme";
import StyledToggle from "../../../../../boundarySelection/ViewTools/StyledToggle";
import useGetOrderItemInrixVolumeParams, {
  InrixVolumeTimePeriod,
} from "./GetOrderItemInrixVolumeParams";
import { formatSegmentLabel } from "../utils/formatSegmentLabel";

const segmentCount = 96;

const OrderItemInrixVolumeSegmentDropdown = () => {
  const { theme } = useThemeContext();
  const { timePeriod, dayOfWeekInUrl, timeSegment, handleSelectTimeSegment } =
    useGetOrderItemInrixVolumeParams();

  if (timePeriod !== InrixVolumeTimePeriod.FIFTEEN_MINS) {
    return null;
  }

  const isDisabled = dayOfWeekInUrl === null;
  const selectedLabel =
    isDisabled ? "Select day first"
    : timeSegment !== null ? formatSegmentLabel(timeSegment)
    : "Select time";

  const handleSelect = (selectedIndex: string | null) => {
    if (selectedIndex === null) return;

    const nextIndex = Number(selectedIndex);
    if (
      !Number.isNaN(nextIndex) &&
      nextIndex >= 0 &&
      nextIndex < segmentCount
    ) {
      handleSelectTimeSegment(nextIndex);
    }
  };

  return (
    <Dropdown onSelect={handleSelect}>
      <StyledToggle
        disabled={isDisabled}
        className={`view-tools-dropdown fs-6 ${theme === Theme.DARK ? "text-white" : "text-black"}`}
        size="lg"
      >
        <span className="toggle-text">{selectedLabel}</span>
      </StyledToggle>
      <Dropdown.Menu
        className="w-100 fs-6"
        style={{ maxHeight: "500px", overflowY: "auto" }}
      >
        {Array.from({ length: segmentCount }, (_, index) => (
          <Dropdown.Item
            key={index}
            eventKey={String(index)}
            active={index === timeSegment}
            className={
              index === timeSegment ? "bg-primary text-white" : undefined
            }
            disabled={isDisabled}
            title={formatSegmentLabel(index)}
          >
            {formatSegmentLabel(index)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default OrderItemInrixVolumeSegmentDropdown;
